<template>
  <div class="exchangeRank" v-if="rankList.length" mg-stat-show="flag=610" mg-stat-lob="smod=exchange_top">
    <p class="module-title">{{info.module_name}}</p>
    <p class="right-tip">向左滑动查看更多</p>
    <div class="rank">
      <div v-for="(item, index) in rankList" :key="index" class="commodity" @click="jump(item)">
        <!-- <Triangle :num="index + 1"/> -->
        <img :src="item.original_img" alt="">
        <p class="item-black-title">{{ item.goods_name }}</p>
        <p class="item-credits">
          <span class="num">{{ item.exchange_integral }}</span><span class="plain">积分</span><span v-if="Number(item.exchange_price) > 0"><span class="plus">+</span><span class="num">{{ parseFloat(item.exchange_price) }}</span><span class="plain">元</span></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Triangle from './triangle'
import { getModuleGoodsList } from '@/utils/service'
import { getHaoWuUrl } from '@/utils/mUtil'
import { loginMixin } from '@/utils/mixin'

export default {
  mixins: [loginMixin],
  data() {
    return {
      info: '',
      rankList: [],
    }
  },
  created() {
    this.moduleList.forEach(val => {
      if (val.type == 2) {
        this.info = val
      }
    })
    this._getRankList()
  },
  methods: {
    async _getRankList() {
      try {
        const res = await getModuleGoodsList({
          module_id: this.info.module_id,
          p: 1,
        })
        this.rankList = res.records.slice(0, 10)
      } catch (error) {
        console.log('_getRankList' + error)
      }
    },
    jump(item) {
      MgStat.send(
        'click',
        {},
        {
          cntp: 'score_newHome',
          mod: 'exchange_top',
          cont: '点击兑换排行榜模块',
        }
      );

      location.href = getHaoWuUrl(item.goods_id, '', 'credits')
    },
  },
  name: 'ExchangeRank',
  props: {
    moduleList: {
      type: Array,
      default: [],
    },
  },
  components: { Triangle },
  computed: {
    proids() {
      return this.rankList.map(v => v.goods_id).join('#')
    },
  },
}
</script>
<style scoped lang="less">
.exchangeRank {
  position: relative;
  background: #ffffff;
  border-radius: 36px;
  // height: 450px;
  overflow: hidden;
  padding-top: 36px;
  padding-bottom: 24px;
  .module-title {
    // font-family: AlimamaFangYuanTiVF-Thin;
    font-weight: 600;
    font-size: 32px;
    padding-left: 36px;

    margin-bottom: 8px;
  }
  .rank {
    overflow-x: scroll;
    overflow-y: hidden;
    padding: 12px 0 10px 30px;
    white-space: nowrap;
    .commodity {
      display: inline-block;
      vertical-align: top;
      width: 240px;
      // height: 310px;
      // border-radius: 20px;
      margin-right: 24px;
      // box-shadow: 0px 0px 10px #eee;
      position: relative;
      .index {
        position: absolute;
        font-size: 22px;
        font-family: KravitzExtraThermal;
        color: #ffffff;
        width: 24px;
      }
      p {
        margin-left: 16px;
        text-align: left;
      }
      img {
        width: 240px;
        height: 240px;
        display: block;
        border-radius: 24px;
        // margin: 10px auto 0;
        background-color: #f6f7f9;
        object-fit: contain;
      }
      .item-black-title {
        width: 219px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 18px;
        font-size: 28px;
        font-weight: 400;
      }
      .item-credits {
        font-size: 22px;
        color: #888888;
        .num {
          font-weight: bold;
          font-size: 26px;
          color: #FF4500;
          font-family: DIN Alternate, DIN Alternate;
        }
        .plain {
          font-weight: 400;
          font-size: 22px;
          color: rgba(0, 0, 0, 0.4);
          margin-left: 6px;
        }
        .plus {
          margin: 0 6px;
        }
      }
    }
  }
  .right-tip {
    position: absolute;
    right: 36px;
    top: 36px;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
  }
}
</style>
